import { Box, Heading, smBumps, xsBumps } from '@wrisk/ui-components'
import React from 'react'

import { Quote } from '../../../domain'
import { useCoreCovers } from '../../../hooks/covers'
import {
  tProduct,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { getExposuresContentBaseUrl, useConfig } from '../../../state/configuration'
import { useProduct } from '../../product/ProductProvider'
import { ConditionalCoverItem } from './ConditionalCoverItem'
import { IncludedCoverItem } from './IncludedCoverItem'

interface CoreCoversListProps {
  quote: Quote
  condensed?: boolean
}

export const CoreCoversList: React.FC<CoreCoversListProps> = ({
  quote,
  condensed = false,
}) => {
  const { t } = useWriskTranslation()
  const { scheme, product } = useProduct()
  const covers = useCoreCovers(quote, product)
  const contentBaseUrl = useConfig(getExposuresContentBaseUrl(scheme.schemeCode))

  const headerTypoSize = condensed ? 'sm' : 'md'
  const typoSize = condensed ? 'sm' : undefined
  const iconSize = condensed ? 'small' : undefined

  return (
    <>
      {covers.map((item, index) => {
        switch (item.type) {
          case 'divider':
            return (
              <Box my={2} px={smBumps} width={1} key={`divider-${index}`}>
                <Box height={0} borderTopWidth={1}>
                  &nbsp;
                </Box>
              </Box>
            )
          case 'header':
            return (
              <Heading
                key={`header-${item.header}`}
                px={smBumps}
                py={xsBumps}
                typoSize={headerTypoSize}
              >
                {t(tProduct('cover-levels', item.header, 'header'))}
              </Heading>
            )
          case 'included':
            return (
              <IncludedCoverItem
                key={`included-${item.coverCode}`}
                code={item.coverCode}
                width={1}
                contentBaseUrl={contentBaseUrl}
                typoSize={typoSize}
                iconSize={iconSize}
              />
            )
          case 'conditional':
            return (
              <ConditionalCoverItem
                key={`conditional-${item.coverCode}`}
                conditionalCover={item}
                width={1}
                typoSize={typoSize}
                iconSize={iconSize}
              />
            )
        }
      })}
    </>
  )
}
